import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import {
  ENDICIA,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'mailing_zip_code'
const VALID_SHIPPER_TYPES = [
  ENDICIA,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  USPS_SHIP,
]

export default function MailingZipCode() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = MailingZipCode.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigTextInput
      label="Mailing Post Office Zip Code"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

MailingZipCode.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
